import { isType } from '@mtna/common';
import { ProcessStatusDetail } from '@rds/rds-base';

import { OptionSet } from '../option/option-set.model';

export interface PackagingProcessWrapper extends ProcessStatusDetail {
  methodName: string;
  options: OptionSet[];
  parameters: { [id: string]: string[] };
  request: string;
  resourceName: string;
  resourceUri: string;
}

export function instanceofPackagingProcessWrapper(something: unknown): something is PackagingProcessWrapper {
  return isType<PackagingProcessWrapper>(something, 'methodName', 'request', 'parameters');
}
